export const handlers = {
  /**
   * The code scan handler.
   *
   * @returns {Promise<string>}
   */
  codeScan: () => {},
  /**
   * The text scan handler.
   *
   * @param {Function} onPhotoCapture
   * @returns {Promise<{ imageDataUrl?: string; status: 'canceled' | 'error' | 'success', textBlocks: string[] }>}
   */
  textScan: () => {},
};

/**
 * Assigns the code scan handler.
 *
 * @param {() => Promise<string>} handler
 */
export function setCodeScanHandler(handler) {
  handlers.codeScan = handler;
}

/**
 * Assigns the text scan handler.
 *
 * @param {() => Promise<string>} handler
 */
export function setTextScanHandler(handler) {
  handlers.textScan = handler;
}

/**
 * Executes the code scan handler.
 */
export function codeScan() {
  return handlers.codeScan();
}

/**
 * Executes the text scan handler.
 *
 * @param {(imageDataUrl: string) => Promise<boolean>} onPhotoCapture
 */
export function textScan(onPhotoCapture) {
  return handlers.textScan(onPhotoCapture);
}
